import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tile } from '@emi/shared/models';

@Component({
  selector: 'via-information-tile',
  templateUrl: './information-tile.component.html',
  styleUrls: ['./information-tile.component.scss']
})
export class InformationTileComponent {
  @Input()
  public tile!: Tile;

  @Output()
  public onButtonClicked = new EventEmitter();

  public buttonClicked(): void {
    this.onButtonClicked.emit();
  }
}
